/* 🤖 this file was generated by svg-to-ts */
export const matIconViewAgenda: {
  name: 'view-agenda';
  data: string;
} = {
  name: 'view-agenda',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 13H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zm0 6H5v-4h14v4zm0-16H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 6H5V5h14v4z"/></svg>`
};
